module.exports = __webpack_public_path__ + "static/img/84091B_1_2_R_20200807_LC.d6923f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84091B_1_2_R_20200807_LC.png
// module id = diQG
// module chunks = 0